<template>
  <b-modal
    :modal-class="wrapperClass"
    header-class="user-menu-modal-header"
    content-class="user-menu-modal-content"
    :body-class="bodyClass"
    :hide-backdrop="withoutBackdrop"
    :id="id"
    :dialog-class="modalClass"
    hide-footer
    :hide-header="hideHeader"
  >
    <template #modal-header="{}">
      <h3 class="menu-modal-title">{{ modalTitle }}</h3>
      <button class="news-close-button" @click="$emit('closeClick')" />
    </template>

    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      require: true,
    },
    modalTitle: {
      type: String,
      require: false,
      default: "Уведомления",
    },
    modalText: {
      type: String,
      require: false,
    },
    buttonText: {
      type: String,
      require: false,
    },
    modalClass: {
      type: String,
      require: false,
    },
    bodyClass: {
      type: String,
      require: false,
    },
    wrapperClass: {
      type: String,
      require: false,
    },
    hideHeader: {
      type: Boolean,
      require: false,
    },
    withoutBackdrop: {
      type: Boolean,
      require: false,
    },
  },
};
</script>

<style>
.user-menu-modal-header {
  padding: 16px 16px 24px;
  border: none;
}

.user-menu-body {
  padding: 0 16px 16px;
}

.user-menu-modal-content {
  border: none;
  background: var(--white-color);
  box-shadow: 0px 15px 40px rgba(5, 6, 36, 0.15);
}

.menu-modal-title {
  font-family: "Ubuntu", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: var(--black-color);
  letter-spacing: -0.008em;
}

.user-menu-list-item {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid var(--grey-color);
}

.user-menu-list-item:first-of-type {
  border-top: 1px solid var(--grey-color);
}

.user-menu-list-icon {
  margin-right: 8px;
}

.user-menu-list-text-block {
  width: 100%;
}

.user-menu-list-text-block-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.user-menu-list-time {
  width: max-content;
  transition: color 0.15s ease-out;
}

/* Нужен ховер для текста, пока нет смысла усложнять компонент */
.user-menu-list-time:hover {
  color: var(--primary-hover-color) !important;
}

.user-menu-list-button {
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  color: var(--primary-color);
  padding: 0;
}
</style>
